module.exports = __webpack_public_path__ + "static/media/attachDocument.dd11c980.svg";